import requester from '@/utils/requester';

const userApi = {
  async update(data: any) {
    return await requester.patch('/user/v1/users/profile', data);
  },
};

export default userApi;
